import styled from 'styled-components';

// DueDate's own Value hardcodes 16px; the sibling grid cells render at 14px.
export const DueDateCell = styled.span`
  > p {
    font-size: 14px;
  }
`;
